
import broken_img from '../../images/image-slash.png';

function image() {
    $( '.markdown-body' ).find( 'img' ).map( ( idx, item ) => {
        const $parent = $( item ).parent(),
              $root   = $parent.parent();
        if ( $root.children() == 1 ) {
            $root.addClass( 'img-center' );
        } else if ( $parent.is( 'a' )) {
            $parent.addClass( 'img-center' );
            //$parent.removeAttr( 'href' );
        }
    });

    $( '.markdown-body' ).find( 'img' ).on( 'error', event => {
        $( event.currentTarget ).attr( 'src', broken_img ).parent().parent().addClass( 'img-broken' );
    });
}

export default function beautify() {
    image();
}